module.exports = __webpack_public_path__ + "static/media/PracticeRanking.88039d58.svg";